<template>
  <div v-show="!loading">
    <!--<ui-modals-greetings />-->
    <div class="bg-secondary tpl-dark" id="tpl-dark-content">
      <template-header :show-actions="showActions" :navbar-type="navbarType" />
      <div id="page-content">
        <slot/>
      </div>
    </div>
    <template-footer/>
  </div>
</template>
<script setup lang="ts">
const loading = ref(true);
// Check when document is loaded
onMounted(()=>{
  loading.value = false;
})

const showActions = ref(false)
provide('showActions', showActions)
const navbarType = ref('dark')
</script>

<style lang="scss">
.tpl-dark{
  color: #ffffff;

  .sa {
    background-color: white; // Imposta lo sfondo bianco su tutte le icone .sa
  }

  // Escludi le icone .sa all'interno di .navbar-end
  .navbar-end {
    .menu{

      .sa {
        background-color: black; // Sovrascrive il bianco solo per le icone in .navbar-end
      }
    }
  }
}
</style>